import React from 'react';
import { Icon } from '@frontend/icons';
import { styles } from '../../../styles';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';

type IndentDecreaseActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const IndentDecreaseAction = ({ compact = true, showBoxShadow = true, ...rest }: IndentDecreaseActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' css={styles.flexCenter}>
        <Icon name='indent-decrease-small' />
      </Text>
    </ActionPressedChip>
  );
};
